import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import {labels} from '../../../../util/utils';
import MotifSelect from '@ey/motif-react-wrapper/Select';
import MotifOption from '@ey/motif-react-wrapper/Option';
import MotifFormField from '@ey/motif-react-wrapper/FormField';
import MotifLabel from '@ey/motif-react-wrapper/Label';
import MotifErrorMessage from '@ey/motif-react-wrapper/ErrorMessage';
import Button from '../../../CoreWrappers/Button';
import {IconoirXmarkCircle} from '@ey-xd/motif-icon';

const AddExisitingDomain = (props) => {
	const {domains} = props;

	const [domainName, setDomainName] = useState('');
	const [showValidationError, setShowValidationError] = useState(false);
	const [duplicateValidation, setDuplicateValidation] = useState(false);
	const [isDisabled, setIsDisabled] = useState(false);

	useEffect(() => {
		checkDuplicate(domainName);
	}, [domains]);

	useEffect(() => {
		const filteredList = props.domainList.filter((el) => el.id !== props.id);
		const defected = filteredList.some((el) => el.isEmpty || el.isDuplicate);

		if (defected) {
			setIsDisabled(true);
		} else {
			setIsDisabled(false);
		}
	}, [props.domainList]);

	useEffect(() => {
		if (props.domainError && domainName === '') {
			setShowValidationError(true);
		}
	}, [props.domainError]);

	const checkDuplicate = (val) => {
		const found = domains.some((el) => el.domainName === val && el.id !== props.id);
		if (found) {
			setDuplicateValidation(true);
			props.setDomainDuplicate(props.id, true);
		} else {
			setDuplicateValidation(false);
			props.setDomainDuplicate(props.id, false);
		}
	};

	const renderRemoveDomainBtn = () => {
		const propsBtn = {
			svg: IconoirXmarkCircle,
			iconSize: 20,
			variant: 'text',
			title: labels.remove,
			onClick: () => {
				props.remove(props.id);
			}
		};
		return <Button {...propsBtn} />;
	};

	return (
		<StyledAddExistingDomain className="add-existing-domain-wrap">
			<MotifFormField>
				<MotifLabel>{labels.domainName}</MotifLabel>
				<MotifSelect
					value={domainName}
					name="motif-select-name"
					id={props.id}
					key={props.id}
					disabled={isDisabled}
					onChange={(val) => {
						setDomainName(val);
						props.updateDomainName(props.id, val);
						setShowValidationError(false);
						checkDuplicate(val);
					}}
					placeholder={props.existingDomains.length === 0 ? labels.noGroupsAdded : ''}
				>
					{props.existingDomains.length > 0 ? (
						props.existingDomains.map((domain) => {
							return (
								<MotifOption key={domain} value={domain}>
									{domain}
								</MotifOption>
							);
						})
					) : (
						<MotifOption key={0} value={0}></MotifOption>
					)}
				</MotifSelect>
				{showValidationError && <MotifErrorMessage>{labels.required} </MotifErrorMessage>}
				{duplicateValidation && <MotifErrorMessage>{labels.duplicateDomain}</MotifErrorMessage>}
			</MotifFormField>
			<span>{renderRemoveDomainBtn()}</span>
		</StyledAddExistingDomain>
	);
};

export default AddExisitingDomain;

const StyledAddExistingDomain = styled.section`
	display: flex;
	justify-content: flex-start;
	width: 100%;
	align-items: flex-start;
	margin-bottom: 2rem;
	.motif-option-text,
	.motif-select-view-value {
		font-size: 1.3rem;
	}
	.motif-form-field-select-input {
		width: 30rem;
		margin-bottom: 0;
	}
	.clearall {
		margin: 0 1.5rem;
		height: 4.4rem;
		align-items: center;
		display: flex;
		svg {
			fill: ${(props) => props.theme.color[`black`]};
		}
	}

	.motif-error-message {
		color: ${(props) => props.theme.color[`red600`]};

		.motif-error-icon {
			width: 2rem;
			height: 2rem;
		}

		svg {
			width: var(--px-20);
			height: var(--px-20);
			max-width: 2rem;
			max-height: 2rem;
			fill: ${(props) => props.theme.color[`red600`]};
			margin: 0 0.5rem 0 0;
			vertical-align: text-bottom;
		}
	}
`;
